module.exports = __webpack_public_path__ + "fe6a7f1f7dcb8aae7f01f2ef37240509.jpg";